import React, { useContext } from "react";
import { ManageFeeLayout, SliderPanel } from "../../../components";
import Table from "../../../components/CsplTable/CsplTable";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ssnMasking, usDateFormat } from "../../../utils";
import ExcelImage from "../../../styles/exportimg.PNG";
import { useState } from "react";
import {
  downloadFeeTransactionSummaryReport,
  getParticipantFeeRunDetailsList,
} from "../../../services";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import moment from "moment";
import { get, isEmpty } from "lodash";
import FileSaver from "file-saver";
import { Image } from "react-bootstrap";
import { manageFeeStore } from "../../../contexts";

const FeeRunParticipantContainer = (props) => {
  const { planId = 1 } = useRouterParams();
  //const planId = 1;
  const [planDetails, setPlanDetails] = useState([]);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const { state, dispatch } = useContext(manageFeeStore);
  const apiData = get(state, "api.data", {});
  const feeTransactionDetails = get(apiData, "feeTransactionDetails", {});
  useDeepEffect(() => {
    getParticipantFeeRunDetailsList(planId).then((response) => {
      if (response.isSuccessfull) {
        setPlanDetails(response.planFeeDetails);
        setEmployeeDetails(response.employeeFeeDetails);
      }
    });
  }, []);
  const tradeDetailsColumns = [
    { columnName: "CUSIP", className: "trade-cusip" },
    { columnName: "Source Name", className: "trade-source-name" },
    {
      columnName: "Clearing Partner & ID",
      className: "trade-clearing-partner",
    },
    { columnName: "Unit", className: "trade-quantity" },
    { columnName: "Amount", className: "trade-amount" },
    { columnName: "NAV", className: "trade-nav" },
    { columnName: "Date", className: "trade-date" },
  ];

  const tradeDetails = {
    transactionId: "A12345098764",
    planName: "Infinte 401(k) plan",
    planId: "122345",
    employeeName: "Kevin Marshall",
    ssn: "9999999999",
    planId: "A12345098764",
    transactionType: "Fee",
    date: "09/26/2020 05:35",
    investments: [
      {
        investmentName: "Apple",
        investmentId: "037833100",
        sourceName: "Pre-Tax",
        clearingPartner: "Aries States",
        clearingPartnerId: "997423567765433",
        quantity: "0.58679",
        tradeType: 1,
        amount: "75.00",
        nav: "2.00",
        date: "09/26/2022 05:35",
      },
      {
        investmentName: "TCS",
        investmentId: "038334350",
        sourceName: "Pre-Tax",
        clearingPartner: "Aries States",
        clearingPartnerId: "997423567765433",
        quantity: "0.58679",
        tradeType: 1,
        amount: "32.00",
        nav: "2.00",
        date: "09/26/2022 05:35",
      },
      {
        investmentName: "Infosys",
        investmentId: "237543100",
        sourceName: "Match",
        clearingPartner: "Aries States",
        clearingPartnerId: "997423567765433",
        quantity: "0.58679",
        tradeType: 1,
        amount: "30.00",
        nav: "1.50",
        date: "09/26/2022 05:35",
      },
    ],
  };
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const columns = [
    {
      label: "Employee Name",
      className: "column-employee-name",
      columnName: "employeeName",
    },
    {
      label: "SSN",
      className: "column-ssn",
      columnName: "uniquePersonalIdentification",
    },
    {
      label: "Fee Collected",
      className: "column-fee-collected",
      columnName: "feeCollected",
    },
    {
      label: "Outstanding Fee",
      className: "column-outstanding-fee",
      columnName: "outstandingFee",
    },
  ];

  return (
    <ManageFeeLayout layoutHeader="Fee Run Details">
      {feeTransactionDetails?.feeRunStatus == "Completed" && (
        <span
          className="mr-2 sort-button d-flex justify-content-end cursor-pointer payroll-btns"
          style={{ lineHeight: "19px" }}
          onClick={() => {
            downloadFeeTransactionSummaryReport(1)
              .then((response) => {
                var blob = new Blob([response], {
                  type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                FileSaver.saveAs(
                  blob,
                  //"PayrollSummary.xlsx"
                  `Fee Transaction Summary Report_ ${usDateFormat(
                    new Date()
                  )}.xlsx`
                );
              })
              .catch((error) => {});
          }}
        >
          <Image src={ExcelImage} width="20px" height="20px" />
          <u>Export</u>
        </span>
      )}
      <div>
        <div className="w-100 d-flex justify-content-between fee-run-plan-card mb-4">
          <div className="d-flex flex-col">
            <span className="plan-details-header">Plan name or ID</span>
            <span className="plan-details-values">{planDetails.planName}</span>
            <span className="plan-details-subValues">
              {planDetails.rkPlanNumber}
            </span>
          </div>
          <div className="d-flex flex-col">
            <span className="plan-details-header">Plan balance</span>
            <span className="plan-details-values">
              $ {planDetails.planBalance}
            </span>
            <span className="plan-details-subValues">
              (As on date {moment().format("DD-MM-YYYY")})
            </span>
          </div>
          <div className="d-flex flex-col pad-top-10">
            <span className="plan-details-header">Fee Collected</span>
            <span className="plan-details-values">
              $ {planDetails.feeAmount}
            </span>
          </div>
          <div className="d-flex flex-col pad-top-10">
            <span className="plan-details-header">Outstanding Fee</span>
            <span className="plan-details-values">
              ${planDetails?.outstandingFee}
            </span>
          </div>
        </div>
        <div className="employee-table-row">
          <Table>
            <Table.Thead>
              <Table.Tr>
                {columns.map((item, index) => {
                  return (
                    <Table.Th key={index} className={item.className}>
                      {item.label}
                    </Table.Th>
                  );
                })}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              <div style={{ height: "45vh", overflow: "scroll" }}>
                {employeeDetails?.map((employee, index) => {
                  return (
                    <Table.Tr key={index}>
                      {columns.map((item, cellIndex) => {
                        return (
                          <Table.Td key={cellIndex} className={item.className}>
                            {item.columnName == "employeeName" ? (
                              feeTransactionDetails?.feeRunStatus ==
                              "Completed" ? (
                                <Link
                                  onClick={() => {
                                    setIsSliderOpen(true);
                                    setActiveIndex(index);
                                  }}
                                >
                                  {employee[item.columnName]}
                                </Link>
                              ) : (
                                employee[item.columnName]
                              )
                            ) : item.columnName ==
                              "uniquePersonalIdentification" ? (
                              ssnMasking(employee[item.columnName])
                            ) : (
                              (item.columnName == "feeCollected" ||
                                item.columnName == "outstandingFee") &&
                              `$ ${employee[item.columnName]}`
                            )}
                          </Table.Td>
                        );
                      })}
                    </Table.Tr>
                  );
                })}
              </div>
            </Table.Tbody>
          </Table>
        </div>
      </div>
      <SliderPanel
        isOpen={isSliderOpen}
        showCancel={true}
        onClose={() => setIsSliderOpen(false)}
        showHeader={true}
        header="Trade Details"
        headerClass="slider-title-case"
        size={90}
      >
        {!isEmpty(planDetails) && !isEmpty(employeeDetails) && (
          <div className="w-100 d-flex trade-details-slider">
            <div
              className="p-3"
              style={{ width: "20%", borderRight: "1px solid #D8D8DC" }}
            >
              <div className="d-flex flex-col mb-3">
                <span className="plan-details-header">Transaction ID</span>
                <span className="plan-details-values">
                  {tradeDetails.transactionId}
                </span>
              </div>
              <div className="d-flex flex-col mb-3">
                <span className="trade-details-header">Plan name or ID</span>
                <span className="plan-details-values">
                  {planDetails.planName}
                </span>
                <span className="plan-details-subValues">
                  {planDetails.rkPlanNumber}
                </span>
              </div>
              <div className="d-flex flex-col mb-3">
                <span className="trade-details-header">Employee Name</span>
                <span className="plan-details-values">
                  {employeeDetails && employeeDetails[activeIndex].employeeName}
                </span>
              </div>
              <div className="d-flex flex-col mb-3">
                <span className="trade-details-header">SSN</span>
                <span className="plan-details-values">
                  {ssnMasking(
                    employeeDetails &&
                      employeeDetails[activeIndex].uniquePersonalIdentification
                  )}
                </span>
              </div>
              <div className="d-flex flex-col mb-3">
                <span className="trade-details-header">Transaction Type</span>
                <span className="plan-details-values">
                  {tradeDetails.transactionType}
                </span>
              </div>
              <div className="d-flex flex-col">
                <span className="trade-details-header">Date</span>
                <span className="plan-details-values">
                  {usDateFormat(planDetails?.feeRunDate)}
                </span>
              </div>
            </div>
            <div className="p-3" style={{ width: "80%" }}>
              <div className="d-flex p-2">
                {tradeDetailsColumns.map((item) => (
                  <p className={`tradeDetails-tableHeader ${item.className}`}>
                    {item.columnName}
                  </p>
                ))}
              </div>

              {tradeDetails.investments.map((item) => (
                <div className="d-flex tradeDetails-investmentCard justify-content-between mb-3">
                  <div className="d-flex flex-col">
                    <span className="trade-details-investment-header">
                      {item.investmentName}
                    </span>
                    <span className="trade-details-investment-value">
                      {item.investmentId}
                    </span>
                  </div>
                  <div className="d-flex flex-col">
                    <span className="trade-details-investment-value-bold">
                      {item.sourceName}
                    </span>
                  </div>
                  <div className="d-flex flex-col">
                    <span className="trade-details-investment-header">
                      {item.clearingPartner}
                    </span>
                    <span className="trade-details-investment-value">
                      {item.clearingPartnerId}
                    </span>
                  </div>
                  <div className="d-flex flex-col">
                    <span className="trade-details-investment-header">
                      {item.quantity}
                    </span>
                    {item.tradeType == 1 ? (
                      <span className="trade-details-investment-value sell">
                        Sell
                      </span>
                    ) : (
                      <span className="trade-details-investment-value buy">
                        Buy
                      </span>
                    )}
                  </div>
                  <div className="d-flex flex-col">
                    <span className="trade-details-investment-value-bold">
                      $ {item.amount}
                    </span>
                  </div>
                  <div className="d-flex flex-col">
                    <span className="trade-details-investment-value-bold">
                      $ {item.nav}
                    </span>
                  </div>
                  <div className="d-flex flex-col pr-3">
                    <span className="trade-details-investment-value-bold-date">
                      {item.date}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </SliderPanel>
    </ManageFeeLayout>
  );
};

export default FeeRunParticipantContainer;
